import { Reveal } from "./Reveal";

const schedule = [
  { time: "7:00", title: "Soundbath Session", desc: "Wake gently to crystal bowls and gongs as the desert glows — a resonant reset for body and mind." },
  { time: "8:30", title: "Mineral Spring Time", desc: "Sink into naturally heated, mineral-rich spring pools beneath the wide morning sky." },
  { time: "10:00", title: "Yoga Renewal", desc: "A slow, intentional flow to open the body and reconnect with breath." },
  { time: "12:30", title: "Wellness Lunch", desc: "A seasonal, nourishing table of fresh, locally sourced dishes — served with intention." },
  { time: "14:30", title: "Guided Desert Walk", desc: "A mindful walk through the Joshua Tree landscape, attuning to stillness and space." },
  { time: "16:00", title: "Self-Realization Journaling", desc: "Quiet, guided reflection to listen inward and meet what's been waiting to surface." },
  { time: "17:30", title: "Goal Setter Session", desc: "Translate insight into intention — a gentle framework for the life you're returning to." },
  { time: "19:00", title: "Goodbye Feast", desc: "A candlelit farewell dinner to celebrate, share and carry the calm home with you." },
];

export const Schedule = () => (
  <section id="day" className="py-24 md:py-32 bg-surface">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <p className="text-xs tracking-[0.3em] uppercase text-clay mb-6">A day at the retreat</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-ink leading-[1.05]">
                One day,<br />unhurried & whole
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 text-muted leading-relaxed max-w-sm">
                Every moment is composed like a piece of music — rising, resting, releasing. Here is
                how a single restorative day unfolds.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ol className="relative border-l border-line ml-2">
            {schedule.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.06}>
                <li data-testid={`schedule-item-${i}`} className="relative pl-10 pb-12 last:pb-0 group">
                  <span className="absolute -left-[7px] top-2 w-3.5 h-3.5 rounded-full bg-sand border-2 border-clay group-hover:bg-clay transition-colors" />
                  <span className="font-sans text-sm text-clay tracking-wide">{s.time}</span>
                  <h3 className="font-serif text-2xl sm:text-3xl text-ink mt-1 leading-tight">{s.title}</h3>
                  <p className="mt-2 text-muted leading-relaxed max-w-xl">{s.desc}</p>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </div>
  </section>
);
